module.exports = __webpack_public_path__ + "img/23.c2899e17.jpg";